import { Controller } from "@hotwired/stimulus"
import Highcharts from 'highcharts'

export default class extends Controller {
  connect() {
    this.initChart()
  }

  initChart() {
    fetch('/index_records')
      .then(response => response.json())
      .then(data => {
        if (data && data.success && Array.isArray(data.labels) && data.labels.length > 0 && Array.isArray(data.data)) {
          const ghqValues = Array.isArray(data.ghq_values) ? data.ghq_values : []
          const parseMonthYear = (label) => {
            if (!label || typeof label !== 'string') return null
            const monthMap = { Jan:0, Feb:1, Mar:2, Apr:3, May:4, Jun:5, Jul:6, Aug:7, Sep:8, Oct:9, Nov:10, Dec:11 }
            const parts = label.split(' ')
            if (parts.length !== 2) return null
            const [monStr, yearStr] = parts
            const month = monthMap[monStr]
            if (month === undefined) return null
            return Date.UTC(Number(yearStr), month, 1)
          }

          const minDate = parseMonthYear(data.labels[0])
          const maxDate = parseMonthYear(data.labels[data.labels.length - 1])

          const filtered = this.filterYearlyData(data.labels, data.data, ghqValues)
          const pricePoints = filtered.labels.map((label, idx) => {
            const [y, m] = (label || '').split('-')
            return [Date.UTC(Number(y), Number(m) - 1 || 0, 1), filtered.prices[idx]]
          })
          const ghqPoints = filtered.labels.map((label, idx) => {
            const [y, m] = (label || '').split('-')
            const ghq = filtered.ghqValues[idx]
            return [Date.UTC(Number(y), Number(m) - 1 || 0, 1), ghq !== undefined ? ghq : null]
          })

          this.renderChart(pricePoints, ghqPoints, minDate, maxDate)
        } else {
          this.element.innerHTML = '<p style="color:#fff;opacity:.9;">Нет данных для графика</p>'
        }
      })
      .catch(() => {
        this.element.innerHTML = '<p style="color:#fff;opacity:.9;">Ошибка загрузки графика</p>'
      })
  }

  filterYearlyData(labels, prices, ghqValues = []) {
    const yearlyMap = new Map()

    const monthNumMap = { Jan:'01', Feb:'02', Mar:'03', Apr:'04', May:'05', Jun:'06', Jul:'07', Aug:'08', Sep:'09', Oct:'10', Nov:'11', Dec:'12' }

    if (labels.length > 0) {
      const [firstMon, firstYear] = labels[0].split(' ')
      const monthNum = monthNumMap[firstMon]
      yearlyMap.set('FIRST_POINT', { label: `${firstYear}-${monthNum}`, price: prices[0], ghq: ghqValues[0] })
    }

    labels.forEach((label, index) => {
      const year = label.split(' ')[1]
      if (year === '2021') return
      if (!yearlyMap.has(year)) {
        yearlyMap.set(year, { label: `${year}-01`, price: prices[index], ghq: ghqValues[index] })
      }
    })

    const lastLabel = labels[labels.length - 1]
    const lastPrice = prices[prices.length - 1]
    const [lastMon, lastYear] = lastLabel.split(' ')
    const lastMonthNum = monthNumMap[lastMon]
    const lastGhq = ghqValues[ghqValues.length - 1]
    yearlyMap.set(`${lastYear}-end`, { label: `${lastYear}-${lastMonthNum}`, price: lastPrice, ghq: lastGhq })

    const sortedEntries = Array.from(yearlyMap.entries()).sort((a, b) => {
      const [yearA, monthA] = [a[1].label.substring(0,4), a[1].label.substring(5,7)]
      const [yearB, monthB] = [b[1].label.substring(0,4), b[1].label.substring(5,7)]
      if (yearA === yearB) return Number(monthA) - Number(monthB)
      return Number(yearA) - Number(yearB)
    })

    return {
      labels: sortedEntries.map(e => e[1].label),
      prices: sortedEntries.map(e => e[1].price),
      ghqValues: sortedEntries.map(e => e[1].ghq)
    }
  }

  renderChart(pricePoints, ghqPoints, minDate, maxDate) {
    const isMobile = window.matchMedia('(max-width: 640px)').matches
    const containerHeight = this.element && this.element.clientHeight ? this.element.clientHeight : 500

    Highcharts.chart(this.element, {
      chart: {
        type: 'spline',
        backgroundColor: 'transparent',
        plotBackgroundColor: 'rgba(7, 78, 107, 1)',
        height: containerHeight,
        spacing: isMobile ? [32, 40, 70, 24] : [30, 40, 80, 20],
        marginBottom: isMobile ? 70 : 80,
        marginLeft: isMobile ? 6 : undefined,
        marginRight: isMobile ? 6 : undefined
      },
      title: {
        text: '',
      },
      legend: {
        enabled: true,
        align: 'center',
        // verticalAlign: 'bottom',
        layout: 'horizontal',
        floating: false,
        itemStyle: { color: '#D0D8DE', fontSize: isMobile ? '11px' : '13px' },
        // margin: isMobile ? 10 : 14,
        // y: 0
      },
      credits: { enabled: false },
      tooltip: {
        shared: true,
        backgroundColor: 'rgba(0,0,0,0.85)',
        style: { color: '#D0D8DE' },
        xDateFormat: '%Y-%m'
      },
      xAxis: {
        type: 'datetime',
        min: minDate,
        max: maxDate,
        tickInterval: 365 * 24 * 3600 * 1000,
        labels: {
          format: '{value:%Y-01}',
          style: { color: '#EAF2F7', fontSize: isMobile ? '11px' : '13px', fontWeight: 600 }
        },
        lineColor: 'rgba(255,255,255,0.85)',
        gridLineColor: 'rgba(255,255,255,0.32)',
        gridLineWidth: 1
      },
      yAxis: [{
        title: { text: null },
        min: 0,
        max: 250,
        tickInterval: 50,
        labels: {
          x: 20,
          y: 0,
          style: { color: '#D0D8DE', fontSize: isMobile ? '10px' : '12px' }
        },
        gridLineColor: 'rgba(255,255,255,0.32)',
        lineColor: 'rgba(255,255,255,0.6)'
      }, {
        title: {
          text: '',
        },
        min: 0,
        max: 2000,
        tickInterval: 500,
        labels: {
          x:  -20,
          y: 0,
          style: { color: '#8FD1FF', fontSize: isMobile ? '10px' : '12px' } },
        gridLineWidth: 0,
        lineColor: 'rgba(143, 209, 255, 0.6)',
        opposite: true
      }],
      plotOptions: {
        series: {
          dataLabels: {
            enabled: false,
            padding: 2,
            x: isMobile ? 0 : 0,
            y: isMobile ? -12 : -8,
            overflow: 'none',
            crop: false
          },
          marker: {
            enabled: true,
            radius: isMobile ? 4 : 5,
            lineWidth: isMobile ? 1.5 : 2
          }
        },
        spline: {
          lineWidth: isMobile ? 2 : 3
        }
      },
      series: [{
        name: 'Цена биопротеина в тыс. руб.',
        data: pricePoints,
        color: '#FF9966',
        yAxis: 0,
        marker: {
          enabled: true,
          radius: isMobile ? 3 : 5,
          lineWidth: isMobile ? 1.5 : 2,
          fillColor: '#FF9966',
          lineColor: '#FF9966'
        },
        dataLabels: {
          enabled: true,
          useHTML: false,
          formatter: function () { 
            const isLastPoint = this.point.index === this.series.data.length - 1
            const isSecondToLast = this.point.index === this.series.data.length - 2
            
            if (isMobile && (isLastPoint || isSecondToLast)) {
              this.point.dataLabel?.attr({
                align: 'right'
              })
            }
            
            return Highcharts.numberFormat(this.y, 0)
          },
          style: { color: '#EAF2F7', textOutline: 'none', fontWeight: 600, fontSize: isMobile ? '10px' : '12px' },
          align: 'center',
          y: isMobile ? -12 : -8,
          crop: false,
          overflow: 'none',
          allowOverlap: true
        },
        tooltip: { valueSuffix: ' тыс. руб.' }
      }, {
        name: 'GHQ-FM4 SMA-3',
        data: ghqPoints,
        color: '#5CC9F5',
        yAxis: 1,
        marker: {
          enabled: true,
          radius: isMobile ? 2.5 : 4,
          symbol: 'circle',
          fillColor: '#5CC9F5',
          lineColor: '#5CC9F5'
        },
        dashStyle: 'ShortDash',
        tooltip: { valueSuffix: ' пунктов' }
      }],
      responsive: {
        rules: [{
          condition: { maxWidth: 640 },
          chartOptions: {
            chart: { spacing: [8, 26, 12, 10] }
          }
        }]
      }
    })
  }
}
